import styled from 'styled-components';
import { IconMapMarker } from '../../common/components/icons/IconMapMarker/IconMapMarker';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { propSwitch } from '../../common/util/propSwitch';
import { PracticeCard } from '../ResultView/ResultList/ProfileCards/search-card/PracticeCard/PracticeCard';

export const Pin = styled(IconMapMarker)`
  color: ${ThemeColours.negative};
  cursor: pointer;
  flex-shrink: 0;
  height: 20px;
  margin-inline-end: 4px;
  padding: 1px;
  width: 14px;
`;

export const MapSlider = styled.div<{ expanded: boolean }>`
  box-shadow: inset 0px 0px 20px 5px rgba(0, 0, 0, 0.75);
  height: ${propSwitch('expanded', '600px', '0px')};
  transition: height 0.25s ease-out;
  width: 100%;
`;

export const MapPracticeCard = styled(PracticeCard)`
  left: 0px;
  opacity: 0.9;
  position: relative;
  top: -10px;
  z-index: 90;
`;
